import { persistStore } from 'redux-persist';
import configure from './setup';

const store = configure();
export const persistor = persistStore(store);

export default store;
